/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "0.1.0 nightly 2025-06-15",
    versionChannel: "nightly",
    buildDate: "2025-06-15T00:08:02.452Z",
    commitHash: "03bd890ad231d4139f9f14b4a439bdac247a687c",
};
